import * as React from "react";
import { Toast, ToastClose, ToastDescription, ToastTitle, ToastPrimitives, type ToastProps } from "../components/ui/toast";
import { ToastContext } from "../hooks/use-toast";

export function ToastProvider({ children }: { children: React.ReactNode }) {
	const [toasts, setToasts] = React.useState<ToastProps[]>([]);

	const showToast = React.useCallback(({ title, description, status, duration = 5000 }: Omit<ToastProps, "id">) => {
		const id = Math.random().toString(36).substring(2, 9);
		setToasts((prev) => [...prev, { id, title, description, status, duration }]);
	}, []);

	const removeToast = React.useCallback((id: string) => {
		setToasts((prev) => prev.filter((toast) => toast.id !== id));
	}, []);

	return (
		<ToastContext.Provider value={{ showToast }}>
			{children}
			<ToastPrimitives.Provider swipeDirection="right">
				{toasts.map((toast) => (
					<Toast
						key={toast.id}
						open={true}
						status={toast.status}
						duration={toast.duration}
						onOpenChange={(open) => {
							if (!open) {
								removeToast(toast.id);
							}
						}}
					>
						<div className="grid gap-1">
							<ToastTitle>{toast.title}</ToastTitle>
							{toast.description && <ToastDescription>{toast.description}</ToastDescription>}
						</div>
						<ToastClose />
					</Toast>
				))}
				<ToastPrimitives.Viewport className="fixed top-0 z-100 flex max-h-screen w-full flex-col-reverse gap-2 p-4 sm:bottom-0 sm:right-0 sm:top-auto sm:flex-col md:max-w-[420px]" />
			</ToastPrimitives.Provider>
		</ToastContext.Provider>
	);
}
